import React from 'react';
import styled from 'styled-components';
import {ThemeDefinition} from '@volkswagen-onehub/components-core';
import {NaturalLanguageFeatureAppTheme} from '@volkswagen-onehub/whitelabel-e-mobility-commons';
import {createNaturalLanguageFeatureAppThemeV26} from './natural-language-theme-v26';
import {
  isV26,
  ThemeWithVariant,
} from '@volkswagen-onehub/vw-e-mobility-components';

export const NaturalLanguageFeatureAppWrapper = (props: {
  children?: React.ReactNode;
}): JSX.Element => <BreakpointsWrapper>{props.children}</BreakpointsWrapper>;

export function createNaturalLanguageFeatureAppVariantTheme(
  theme: ThemeWithVariant
) {
  return isV26(theme)
    ? createNaturalLanguageFeatureAppThemeV26(theme)
    : createNaturalLanguageFeatureAppTheme(theme);
}
export function createNaturalLanguageFeatureAppTheme(
  theme: ThemeDefinition
): NaturalLanguageFeatureAppTheme {
  return {
    colors: {
      outputArea: {
        background:
          'linear-gradient(rgb(243, 244, 245) 50%, rgb(223, 228, 232) 100%)',
      },
    },
    spacing: {
      appLayout: {
        blockGap: theme.size.grid001,
      },
      contentLayout: {
        inlineStart: 'var(--content-layout-inline-start)',
        inlineEnd: 'var(--content-layout-inline-end)',
      },
      inputSectionLayout: {
        blockStart: theme.size.dynamic0130,
        blockEnd: theme.size.dynamic0130,
      },
    },
    elements: {
      inputArea: {
        gap: theme.size.static350,
        textGap: theme.size.static200,
        selectWidth: '240px',
      },
      outputArea: {
        padding: theme.size.dynamic0100,
        result: {
          gap: theme.size.static350,
        },
        borderRadius: theme.size.static0,
      },
      efficiencyDataSeparator: '\u00a0• ',
    },
  };
}

const BreakpointsWrapper = styled.div`
  --content-layout-inline-start: ${(props) => props.theme.size.grid002};
  --content-layout-inline-end: ${(props) => props.theme.size.grid002};
`;
